import type { CSSProperties } from 'react';
import React from 'react';
import { cloneObjectWithPrefixedProperties } from '@noths/polaris-client-utils';

import * as styles from './SvgIcon.styles';
import type { ThemeColorOrCSSVar } from 'client-ribbons-design-system/types/color';
import type { IconSize } from 'client-ribbons-design-system/types/icons';

interface IconCSS extends CSSProperties {
  '--iconColor'?: string;
  '--iconImage': string;
}

export interface IconProps {
  className?: string;
  color?: ThemeColorOrCSSVar | 'currentColor';
  dataAttributes?: Record<string, string>;
  height?: IconSize;
  width?: IconSize;
}

export interface SvgIconProps extends IconProps {
  src: string;
  testId?: string;
}

/** @deprecated Use the Icon component from the design-system-core-components package. */
export const SvgIcon = ({
  className,
  color,
  dataAttributes,
  height,
  src,
  testId,
  width,
}: SvgIconProps) => (
  <span
    className={className}
    css={styles.iconWrapper}
    style={{ width, height }}
    {...cloneObjectWithPrefixedProperties(dataAttributes, 'data-')}
  >
    <span
      css={[styles.icon]}
      data-testid={testId}
      style={
        {
          '--iconColor': color,
          '--iconImage': `url("${src}")`,
        } as IconCSS
      }
    />
  </span>
);
